import type { CenterDaySchedule } from '@api/types';

// Display order: Mon(1) Tue(2) Wed(3) Thu(4) Fri(5) Sat(6) Sun(0) in internal 0=Sun array
export const DISPLAY_TO_WEEKDAY = [1, 2, 3, 4, 5, 6, 0] as const;
export const DAY_NAMES = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

export interface DayState { closed: boolean; open: string; close: string }

export const DEFAULT_BH: DayState[] = [
  { closed: false, open: '09:00', close: '20:00' },
  { closed: false, open: '09:00', close: '20:00' },
  { closed: false, open: '09:00', close: '20:00' },
  { closed: false, open: '09:00', close: '20:00' },
  { closed: false, open: '09:00', close: '20:00' },
  { closed: true,  open: '09:00', close: '14:00' },
  { closed: true,  open: '09:00', close: '14:00' },
];

export function bhFromApi(bh: (CenterDaySchedule | null)[] | null | undefined): DayState[] {
  if (bh?.length !== 7) return DEFAULT_BH.map((d) => ({ ...d }));
  return DISPLAY_TO_WEEKDAY.map((wd) => {
    const entry = bh[wd];
    return entry ? { closed: false, open: entry.open, close: entry.close } : { closed: true, open: '09:00', close: '14:00' };
  });
}

export function bhToApi(days: DayState[]): (CenterDaySchedule | null)[] {
  const result: (CenterDaySchedule | null)[] = new Array(7).fill(null) as (CenterDaySchedule | null)[];
  DISPLAY_TO_WEEKDAY.forEach((wd, i) => {
    const d = days[i];
    result[wd] = d.closed ? null : { open: d.open, close: d.close };
  });
  return result;
}

export const TIMEZONE_OPTIONS = [
  { group: 'España', options: [
    ['Europe/Madrid', 'Europe/Madrid (Península y Baleares)'],
    ['Atlantic/Canary', 'Atlantic/Canary (Canarias)'],
  ]},
  { group: 'Europa', options: [
    ['Europe/London', 'Europe/London'],
    ['Europe/Paris', 'Europe/Paris'],
    ['Europe/Berlin', 'Europe/Berlin'],
    ['Europe/Rome', 'Europe/Rome'],
    ['Europe/Lisbon', 'Europe/Lisbon'],
    ['Europe/Amsterdam', 'Europe/Amsterdam'],
    ['Europe/Brussels', 'Europe/Brussels'],
    ['Europe/Zurich', 'Europe/Zurich'],
    ['Europe/Warsaw', 'Europe/Warsaw'],
    ['Europe/Moscow', 'Europe/Moscow'],
  ]},
  { group: 'América', options: [
    ['America/Mexico_City', 'America/Mexico_City'],
    ['America/Bogota', 'America/Bogota'],
    ['America/Lima', 'America/Lima'],
    ['America/Santiago', 'America/Santiago'],
    ['America/Argentina/Buenos_Aires', 'America/Argentina/Buenos_Aires'],
    ['America/New_York', 'America/New_York'],
    ['America/Chicago', 'America/Chicago'],
    ['America/Los_Angeles', 'America/Los_Angeles'],
    ['America/Sao_Paulo', 'America/Sao_Paulo'],
  ]},
  { group: 'Resto del mundo', options: [
    ['Asia/Dubai', 'Asia/Dubai'],
    ['Asia/Kolkata', 'Asia/Kolkata'],
    ['Asia/Singapore', 'Asia/Singapore'],
    ['Asia/Tokyo', 'Asia/Tokyo'],
    ['Australia/Sydney', 'Australia/Sydney'],
    ['UTC', 'UTC'],
  ]},
];

export function originsFromApi(origins: string[] | undefined): string {
  return Array.isArray(origins) ? origins.join('\n') : '';
}

export function originsToApi(raw: string): string[] {
  return raw.split('\n').map((s) => s.trim()).filter(Boolean);
}
